/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BronzeIdPreconfigRequest
 */
export interface BronzeIdPreconfigRequest {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof BronzeIdPreconfigRequest
     */
    orgId: string;
    /**
     * Org emails domain
     * @type {string}
     * @memberof BronzeIdPreconfigRequest
     */
    domain: string;
    /**
     * How user proofs that they have access to the domain
     * @type {string}
     * @memberof BronzeIdPreconfigRequest
     */
    dnsCheckMode: BronzeIdPreconfigRequestDnsCheckModeEnum;
    /**
     * Expected text in DNS records, present only if dnsCheckMode is TEXT_RECORD
     * @type {string}
     * @memberof BronzeIdPreconfigRequest
     */
    dnsExpectedText?: string;
    /**
     * Org lei
     * @type {string}
     * @memberof BronzeIdPreconfigRequest
     */
    lei?: string;
    /**
     * If this flag is not set, service would return an error in case if we have completed workflows with the same type
     * @type {boolean}
     * @memberof BronzeIdPreconfigRequest
     */
    createIfCompleted?: boolean;
}


/**
 * @export
 */
export const BronzeIdPreconfigRequestDnsCheckModeEnum = {
    TextRecord: 'TEXT_RECORD',
    UploadedFile: 'UPLOADED_FILE'
} as const;
export type BronzeIdPreconfigRequestDnsCheckModeEnum = typeof BronzeIdPreconfigRequestDnsCheckModeEnum[keyof typeof BronzeIdPreconfigRequestDnsCheckModeEnum];


/**
 * Check if a given object implements the BronzeIdPreconfigRequest interface.
 */
export function instanceOfBronzeIdPreconfigRequest(value: object): boolean {
    if (!('orgId' in value)) return false;
    if (!('domain' in value)) return false;
    if (!('dnsCheckMode' in value)) return false;
    return true;
}

export function BronzeIdPreconfigRequestFromJSON(json: any): BronzeIdPreconfigRequest {
    return BronzeIdPreconfigRequestFromJSONTyped(json, false);
}

export function BronzeIdPreconfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BronzeIdPreconfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orgId': json['orgId'],
        'domain': json['domain'],
        'dnsCheckMode': json['dnsCheckMode'],
        'dnsExpectedText': json['dnsExpectedText'] == null ? undefined : json['dnsExpectedText'],
        'lei': json['lei'] == null ? undefined : json['lei'],
        'createIfCompleted': json['createIfCompleted'] == null ? undefined : json['createIfCompleted'],
    };
}

export function BronzeIdPreconfigRequestToJSON(value?: BronzeIdPreconfigRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orgId': value['orgId'],
        'domain': value['domain'],
        'dnsCheckMode': value['dnsCheckMode'],
        'dnsExpectedText': value['dnsExpectedText'],
        'lei': value['lei'],
        'createIfCompleted': value['createIfCompleted'],
    };
}

